// extracted by mini-css-extract-plugin
module.exports = {"none":"Language_none__35w77","wip":"Language_wip__3OEKI","testing":"Language_testing__1UPjR","unknown":"Language_unknown__1xOTn"};